import { connect } from "react-redux";

import actions from "../../actions";
import SpecialProcessBundleEditor from "../../components/list/SpecialProcessBundleEditor";

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItemBundle: (data, handleSuccess, handleCancel) =>
      dispatch(actions.schedule_chiba.updateItemBundle(data, handleSuccess, handleCancel)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecialProcessBundleEditor);
